
import Vue from 'vue'

export default Vue.extend({
   name: 'CheckboxRecaptcha',
   computed: {
      recaptchaSiteKey(): string {
         return this.$store.state.modelData.RecaptchaSiteKey
      },
      recaptchaRefreshRequired(): string {
         return this.$store.state.recaptchaRefreshRequired
      },
   },
   mounted() {
      this.startRecaptcha()
   },
   watch: {
      recaptchaRefreshRequired(refreshRequired: boolean) {
         if (refreshRequired) {
            this.recaptchaExpired()
            this.$store.commit('setRecaptchaRefreshRequired', false)
         }
      },
   },
   methods: {
      startRecaptcha() {
         const recaptcha = (window as any).grecaptcha
         if (!recaptcha || !recaptcha.render) {
            setTimeout(this.startRecaptcha, 250)
         } else {
            recaptcha.render('recaptcha', {
               sitekey: this.recaptchaSiteKey,
               callback: this.recaptchaCompleted,
               'expired-callback': this.recaptchaExpired,
               'error-callback': this.recaptchaError,
            })
         }
      },
      recaptchaCompleted(token: string) {
         this.$store.commit('setRecaptchaToken', token)
      },
      recaptchaExpired() {
         this.$store.commit('setRecaptchaToken', '')
         ;(window as any).grecaptcha.reset()
      },
      recaptchaError() {
         this.$store.commit('setRecaptchaToken', '')
         ;(window as any).grecaptcha.reset()
      },
   },
})
